import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IReportData } from '@models/reports/IReportData';
import { IReportScheme } from '@models/reports/IReportScheme';
import { IReportFormats } from '@models/reports/IReportFormats';
import { SLICE_NAMES } from '@/constants';

export interface IReportState {
    /** Идёт выгрузка построенного отчёта: у кнопки «Скачать» прелоадер. */
    isBuilding: boolean;
    scheme?: IReportScheme;
    data?: IReportData;
    formats?: IReportFormats;
}

const initialState: IReportState = {
    isBuilding: false,
    scheme: undefined,
    data: undefined,
};

export const ReportSlice = createSlice({
    name: SLICE_NAMES.REPORT,
    initialState,
    reducers: {
        setIsBuilding: (state, action: PayloadAction<boolean>) => {
            state.isBuilding = action.payload;
        },

        successLoadScheme: (state, action: PayloadAction<IReportScheme>) => {
            state.scheme = action.payload;
        },
        successLoadData: (state, action: PayloadAction<IReportData>) => {
            state.data = action.payload;
        },
        successLoadTypes: (state, action: PayloadAction<IReportFormats>) => {
            state.formats = action.payload;
        },
        reset: (state) => {
            state.scheme = undefined;
            state.data = undefined;
            state.formats = undefined;
        },
    },
});

export const { setIsBuilding, successLoadScheme, successLoadData, successLoadTypes } = ReportSlice.actions;

export default ReportSlice.reducer;
